import { createElement } from "./utils/DOMutils";

export function toPascalCase(str) {
    return str
        .match(/[a-z]+/gi)
        .map(function(word) {
            return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
        })
        .join("");
}

export function initModules(modules = {}, options = {}) {
    const { prefix } = Object.assign({ prefix: "js-module-" }, options);
    Array.from(document.querySelectorAll(`[class*='${prefix}']`), (element) => {
        const name = element.className
            .split(prefix)
            .pop()
            .split(" ")[0];
        const fn = toPascalCase(name);
        if (typeof modules[fn] === "function") {
            modules[fn](element);
        }
    });
}

export const loadScript = (url, condition) =>
    new Promise((resolve, reject) => {
        if (!condition) return reject();

        const script = createElement("script", { type: "text/javascript", src: url, defer: true });

        document.head.appendChild(script);
        script.addEventListener("load", resolve);
    });
